import { AfterViewInit, Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import {
  IJsonViewBlock,
  IPrintData,
} from '../../shared/Entities/json-view.entities';

@Component({
  selector: 'app-print-html',
  templateUrl: './print-html.component.html',
  styleUrls: ['./print-html.component.scss'],
})
export class PrintHtmlComponent implements OnInit, AfterViewInit {
  data: IJsonViewBlock[];

  constructor(
    private appComponent: AppComponent,
    private route: ActivatedRoute
  ) {}

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    const storageData = localStorage.getItem('printdata');
    const key = this.route.snapshot.paramMap.get('key');
    if (storageData != null) {
      const allPrintData = JSON.parse(storageData);
      delete allPrintData[key];
      localStorage.setItem('printdata', JSON.stringify(allPrintData));
    }
  }

  ngOnInit() {
    this.appComponent.disableNav();
    const key = this.route.snapshot.paramMap.get('key');
    const storageData = localStorage.getItem('printdata');
    if (storageData != null) {
      const allPrintData: IPrintData = JSON.parse(storageData);
      if (!allPrintData.hasOwnProperty(key)) {
        window.close();
      }
      this.data = allPrintData[key];
    }
  }

  ngAfterViewInit() {
    window.print();
  }
}
